import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "store"

export enum FeatureFlag {
  ThermV2Ordering = "thermv2ordering",
  SensorsOrdering = "sensors-ordering",
  EnterpriseDashboard = "fe_dashboard_enteprise",
}

interface FeatureFlagsState {
  enabledFlags: string[]
}

const initialState: FeatureFlagsState = {
  enabledFlags: [],
}

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    setEnabledFeatureFlags: (state, action: PayloadAction<string[]>) => {
      state.enabledFlags = action.payload
    },
  },
})

export const { setEnabledFeatureFlags } = featureFlagsSlice.actions

export const isFeatureEnabled =
  (flag: FeatureFlag) =>
  (state: RootState): boolean =>
    state.featureFlags.enabledFlags.includes(flag)

export default featureFlagsSlice.reducer
